import React from 'react';
import Box from "@mui/material/Box";
import GeneralShop from "./GeneralShop";
import {contentTexts} from "../ContentText";
import TopTitle from "../Components/TopTitle";
import SubTitle from "../Components/SubTitle";

function PackagesSection(props) {
    return (
        <Box className={"flexColumnCenter"}  ref={props.refs} sx={{width: '100%',
        }}>

            <TopTitle>{"Packages"}</TopTitle>
            <SubTitle>{"Mehr Leistung für weniger Kosten"}</SubTitle>
            <GeneralShop sx={{width: "100%", marginTop: "150px", marginBottom: "40px" }}
                         data={contentTexts.packageActionsContent}></GeneralShop>
        </Box>
    );
}

export default PackagesSection;